module.exports = __webpack_public_path__ + "img/stoneholder-1@2x.da8e309.webp";